export default __webpack_public_path__ + "fd03cb507e43d31950374ff5260605ca.png";